// DO NOT MODIFY, this file is autogenerated by tools/build.ts
export * from 'firebase/app';
import { ɵzoneWrap } from '@angular/fire';
import {
  deleteApp as _deleteApp,
  getApp as _getApp,
  getApps as _getApps,
  initializeApp as _initializeApp,
  onLog as _onLog,
  registerVersion as _registerVersion,
  setLogLevel as _setLogLevel
} from 'firebase/app';

export const deleteApp = ɵzoneWrap(_deleteApp, true);
export const getApp = ɵzoneWrap(_getApp, true);
export const getApps = ɵzoneWrap(_getApps, true);
export const initializeApp = ɵzoneWrap(_initializeApp, true);
export const onLog = ɵzoneWrap(_onLog, true);
export const registerVersion = ɵzoneWrap(_registerVersion, true);
export const setLogLevel = ɵzoneWrap(_setLogLevel, true);
